import { render, staticRenderFns } from "./veSbzcCdInfo.vue?vue&type=template&id=10f1a955&scoped=true"
import script from "./veSbzcCdInfo.vue?vue&type=script&lang=js"
export * from "./veSbzcCdInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10f1a955",
  null
  
)

export default component.exports